import axios from 'axios';


const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const handleLogout = () => {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('token')
    localStorage.removeItem('tabIndex')
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/';
};

// Create an Axios instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});



// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);
const handle401Error = (error) => {
    if (error.response && error.response.status === 401) {
        handleLogout();
    }
    return Promise.reject(error);
};

// Add response interceptor to api instance
api.interceptors.response.use(
    (response) => response,
    handle401Error
);

// For multipart/form-data requests
const formApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

// Add a request interceptor to formApi
formApi.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

formApi.interceptors.response.use(
    (response) => response,
    handle401Error
);

const formApiUpload = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/octet-stream',
    },
});

// Add a request interceptor to formApi
formApiUpload.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

formApiUpload.interceptors.response.use(
    (response) => response,
    handle401Error
);

export const AudioHandler = {

    async doGetAllRecording() {
        try {
            const { data } = await api.get(`audio/find?type=all&limit=0`);
            return data;
        } catch (error) {
            return error;
        }
    },

    // async doGetFilterRecording(desc) {
    //     try {
    //         const { data } = await api.get(`audio/find?name=${desc}`);
    //         return data;
    //     } catch (error) {
    //         return error;
    //     }
    // },

    async doGetFolderRecording(id) {

        try {
            const { data } = await api.get(`audio/find?type=folder&id=${id}`);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doGetFilterRecording(id) {
        try {
            if (id) {
                const { data } = await api.get(`audio/find?type=folder&id=${id}`);
                return data;
            } else {
                const { data } = await api.get(`audio/find?type=all&limit=0`);
                return data;
            }

        } catch (error) {
            return error;
        }
    },

    async doUploadAudioUrl(formData, FolderId) {
        try {
            if (FolderId === undefined || FolderId === null) {
                const { data } = await formApiUpload.post(`audio/upload`, formData, {
                    headers: {
                        'Content-Type': 'application/octet-stream',
                    }
                });
                return data;
            } else {
                const { data } = await formApiUpload.post(`audio/upload?folderId=${FolderId}`, formData, {
                    headers: {
                        'Content-Type': 'application/octet-stream',
                    }
                });
                // console.log(data, 'audiodata')
                return data;
            }

        } catch (error) {
            return error;
        }
    },

    async doDeleteRecording(id) {

        try {
            const { data } = await api.delete(`audio/delete/${id}`);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doUpdateRecording(id, payload) {
        try {
            const { data } = await api.patch(`audio/update/${id}`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doConvertAudioRecording(id, payload, FolderId) {
        try {
            if (FolderId === undefined || FolderId === null) {
                const { data } = await api.post(`audio/convert/${id}`, payload);
                return data;
            } else {
                const { data } = await api.post(`audio/convert/${id}?folderId=${FolderId}`, payload);
                return data;
            }

        } catch (error) {
            return error;
        }
    },

    async doHandalMergeAudio(payload, cancelToken, folderId) {
        try {

            if (!folderId || (folderId === undefined || folderId === null)) {
                const response = await api.post('audio/merge-file', payload, {
                    cancelToken: cancelToken,
                });
                return response.data;
            } else {
                const response = await api.post(`audio/merge-file?folderId=${folderId}`, payload, {
                    cancelToken: cancelToken,
                });
                return response.data;
            }

        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request was canceled');
            } else {
                console.log('Request failed', error);
            }
            throw error; // Re-throw the error to handle it further up the call stack if needed
        }
    },


    async doHandalTrimAudio(formData, folderId) {
        try {
            if (!folderId || (folderId === undefined || null)) {
                const { data } = await formApi.post(`audio/trim-file`, formData);
                return data;
            } else {
                const { data } = await formApi.post(`audio/trim-file?folderId=${folderId}`, formData);
                return data;
            }
        } catch (error) {
            return error;
        }
    },


    async doMoveToFolder(payload) {
        try {
            // const { data } = await api.post(`audio/move?audioId=${audioId}&folderId=${folderId}`);
            const { data } = await api.post(`audio/move`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },



    // async doHandalGetTranscriptAudio(audioId) {
    //     try {
    //         const { data } = await api.get(`audio/retrieve/${audioId}`);
    //         // console.log(data, 'datatranscribe')
    //         return data;
    //     } catch (error) {
    //         return error;
    //     }
    // },



    async doHandalCopyAudio(audioId, folderId) {
        try {
            if (!folderId || (folderId === undefined || null)) {
                const { data } = await api.post(`audio/copy/${audioId}`);
                return data;
            } else {
                const { data } = await api.post(`audio/copy/${audioId}?folderId=${folderId}`);
                return data;
            }
        } catch (error) {
            return error;

        }
    },

    async doHandalGetDownloadAudio(audioId) {
        const requestOptions = {
            method: "GET",
            responseType: "arraybuffer"
        };
        try {
            const response = await axios.get(
                `${BASE_URL}audio/download/${audioId}`, requestOptions);
            const { data, error } = response;
            return { status: true, data: data };
        } catch (error) {
            return error;
        }

    },

    // Starts the AI transcription job; pass FormData (audiofile + uploadRequired) to upload a new file.
    async doHandalStartTranscribeAudio(payload) {
        try {
            const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
            const { data } = isFormData
                ? await formApi.post(`audio/transcription`, payload)
                : await api.post(`audio/transcription`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    // The transcript is written by a webhook, so the UI asks for it on demand.
    async doHandalGetTranscriptionStatus(audioId) {
        try {
            const { data } = await api.get(`audio/transcription/status/${audioId}`);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandalGetTranscribeAudioDataFromId(id) {
        try {
            const { data } = await api.get(`audio/web/transcript/${id}`)
            // console.log(data, 'datatranscribe')
            return data;
        } catch (error) {
            return error;
        }
    },


    async doHandalSaveTranscriptAudio(payload) {
        try {
            const { data } = await api.post('audio/save-transcript', payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doSaveTranslation(audioId, payload) {
        try {
            const { data } = await api.post(`audio/save-translation/${audioId}`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandalUpdateTranscriptAudio(payload) {
        try {
            const { data } = await api.put(`audio/update-transcript`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },


    async doMoveToHomeAudio(payload) {
        try {
            const { data } = await api.post(`audio/home`, payload);
            return data
        } catch (error) {

        }
    }

}


